import Tooltip from '../../../Tooltip';

const ConditionalTooltip = (props) => {
  const {
    showTooltip, children, tooltipProps, tooltipMessage,
  } = props;

  if (showTooltip) {
    return (
      <Tooltip
        icon={children}
        {...tooltipProps}
      >
        {tooltipMessage}
      </Tooltip>
    );
  }
  return children;
};

export default ConditionalTooltip;
